import { push } from '@takeshape/redux-little-router';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type RedirectStateProps = {
  readonly from?: RegExp;
  readonly to?: string;
};

const Redirect: React.FC<RedirectStateProps> = (props) => {
  const { to, from } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    if (to && from) {
      dispatch(push(`${location.pathname.replace(from, to)}${location.search}`));
    }
  }, [dispatch, from, to]);

  return null;
};

export default Redirect;
